import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Building2, TrendingUp, Warehouse, Code2 } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { Section, FadeIn, PageHero } from '../components/ui-bits';
import Breadcrumb from '../components/Breadcrumb';

const QueHacemos = () => {
  const { t } = useLanguage();

  const verticals = [
    { key: 'v1', icon: Building2, to: '/que-hacemos/gestion-inmobiliaria', num: '01' },
    { key: 'v2', icon: TrendingUp, to: '/que-hacemos/inversion-inmobiliaria', num: '02' },
    { key: 'v3', icon: Warehouse, to: '/que-hacemos/bodegaje-industrial', num: '03' },
    { key: 'v4', icon: Code2, to: '/que-hacemos/desarrollo-software', num: '04' },
  ];

  return (
    <div data-testid="what-we-do-page">
      <Breadcrumb items={[{ to: null, label: t.nav.whatWeDo }]} />
      <PageHero eyebrow={t.whatWeDo.eyebrow} title={t.whatWeDo.title} intro={t.whatWeDo.subtitle} />

      <Section className="pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {verticals.map((v, i) => {
            const Icon = v.icon;
            const data = t.verticals[v.key];
            return (
              <FadeIn key={v.key} delay={i * 0.08}>
                <Link
                  to={v.to}
                  data-testid={`wwd-vertical-${v.key}`}
                  className="group card-hover relative block rounded-3xl border border-white/10 bg-white/[0.025] p-8 md:p-12 h-full overflow-hidden"
                >
                  <div className="flex items-start justify-between mb-10">
                    <div className="flex items-center gap-4">
                      <div className="w-14 h-14 rounded-2xl bg-amber-300/10 border border-amber-300/20 flex items-center justify-center text-amber-300">
                        <Icon className="w-6 h-6" />
                      </div>
                      <span className="font-display text-sm text-white/40 tracking-widest">{v.num}</span>
                    </div>
                    <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-amber-300/80">
                      <span>{t.whatWeDo.exploreCta}</span>
                      <ArrowUpRight className="w-4 h-4 group-hover:rotate-12 transition-transform" />
                    </div>
                  </div>
                  <h3 className="font-display font-extrabold text-3xl md:text-4xl text-white tracking-tight leading-tight">
                    {data.title}
                  </h3>
                  <p className="mt-5 font-body text-base md:text-lg text-white/60 leading-relaxed max-w-md">
                    {data.long}
                  </p>
                </Link>
              </FadeIn>
            );
          })}
        </div>
      </Section>
    </div>
  );
};

export default QueHacemos;
